import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild} from '@angular/core';
import {TtsControlEnum} from '@core/enums/tts-control.enum';
import {debounce} from 'lodash';
import {TranslateService} from '@ngx-translate/core';
import {FormControl, FormGroup} from '@angular/forms';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {LoggedUserDataModel} from '@core/modules/rest/user/response/logged-user-data.model';
import {Observable} from 'rxjs';
import {CoreReducer} from '@core/store';
import {Store} from '@ngrx/store';
import {AppState} from '@core/reducers';
import {KeycloakApplicationRolesEnum} from '@core/modules/rest/user/enums/keycloak-application-roles.enum';
import {MedicalFieldEnum} from '@core/modules/rest/indication/enums/medical-field.enum';

@UntilDestroy()
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit {
    @ViewChild('select', {static: false}) select: ElementRef;
    @Input() headerIcon: string | undefined;
    @Input() headerText: string | undefined;
    @Input() headerParagraph: string | undefined;
    @Input() showActionButton = false;
    @Input() backButtonDisplayed: boolean | undefined;
    @Input() backButtonLabel: string | undefined;
    @Input() actionButtonText: string | undefined;
    @Input() leaveButton = false;
    @Input() leaveButtonLabel: string;
    @Input() indicationTitle = false;
    @Input() indicationName: string | undefined;
    @Input() showHeaderControls = false;
    @Input() repeatButtonDisabled = true;
    @Input() ttsIconState: TtsControlEnum | undefined;
    @Input() showSearch = false;
    @Input() showSelect = false;
    @Input() searchTriggerDelay = 600;
    @Output() buttonEvent: EventEmitter<string> = new EventEmitter();
    @Output() playFromStartAudioEvent: EventEmitter<void> = new EventEmitter();
    @Output() leaveIndication: EventEmitter<void> = new EventEmitter();
    @Output() readTextEvent: EventEmitter<void> = new EventEmitter();
    @Output() searchTextEvent: EventEmitter<string> = new EventEmitter();
    @Output() selectChangeEvent: EventEmitter<any> = new EventEmitter();
    playState = TtsControlEnum.playState;
    searchPlaceholder: string;
    showButton = false;
    form: FormGroup;
    searchFormControl: FormControl = new FormControl();
    username: any;
    allRoles: KeycloakApplicationRolesEnum[] = [];
    loggedUserInfo$: Observable<LoggedUserDataModel> = this.store.select(CoreReducer.loggedUserDataSelector);
    selectedRoles: KeycloakApplicationRolesEnum[] = [];
    customIcon: boolean;

    fieldOptions = [];
    medicalFieldSelected: MedicalFieldEnum = MedicalFieldEnum.OPHTHALMOLOGY;

    constructor(private translate: TranslateService, private renderer: Renderer2, private store: Store<AppState>) {
        this.onNewInput = debounce(this.onNewInput, this.searchTriggerDelay);
        this.searchPlaceholder = this.translate.instant('GENERAL.SEARCH');
    }

    ngOnInit(): void {
        this.loggedUserInfo$.pipe(untilDestroyed(this))
            .subscribe((loggedUserData: LoggedUserDataModel) => {
                this.username = loggedUserData.username;
                this.allRoles = loggedUserData.roles;
                this.selectedRoles = this.allRoles.slice(0, -1);
                this.customIcon = !this.selectedRoles.includes(KeycloakApplicationRolesEnum.PATIENT);
            });
        this.form = new FormGroup({
            search: this.searchFormControl
        });
        this.form.controls.search.valueChanges.pipe(untilDestroyed(this)).subscribe((val) => {
            this.showButton = val.length !== 0;
        });
        this.fieldOptions.push({
            selectId: MedicalFieldEnum.OPHTHALMOLOGY,
            selectValue: this.translate.instant('GENERAL.OPHTHALMOLOGY')
        });
    }

    ngAfterViewInit(): void {
        if (this.showSelect === true) {
            const grid = this.select?.nativeElement.querySelector('.select-wrapper');
            this.renderer.setStyle(grid, 'grid-column-gap', '16px');
        }
    }

    readText(): void {
        this.readTextEvent.emit();
    }

    playFromStart(): void {
        this.playFromStartAudioEvent.emit();
    }

    onNewInput(): void {
        this.searchTextEvent.emit(this.searchFormControl.value);
    }

    clear(): void {
        this.searchFormControl.setValue('');
        this.onNewInput();
    }

    onSelectChange(value: any): void {
        this.medicalFieldSelected = value;
        this.selectChangeEvent.emit(this.medicalFieldSelected);
    }

    iconsForOtherRoles(icon: string): any {
        switch (icon) {
            case KeycloakApplicationRolesEnum.ADMIN:
                return 'admin';
            case KeycloakApplicationRolesEnum.DOCTOR:
                return 'doctor';
            case KeycloakApplicationRolesEnum.CONTENTEDITOR:
                return 'editor';
        }
    }
}
